import { useState } from "react";
import {
  Paper,
  Typography,
  Box,
  IconButton,
} from "@material-ui/core";
import {
  AttachMoney as BillingIcon,
  Assessment as StatsIcon,
  ArrowBack as BackIcon,
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { AdminContainer } from "../../components/layouts";
import BillingPanel from "./BillingPanel";
import EnrollmentStatsPanel from "./EnrollmentStatsPanel";

const useCardStyles = makeStyles((theme) => ({
  cardGrid: {
    display: "flex",
    gap: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  card: {
    flex: 1,
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    transition: "box-shadow 0.2s ease, transform 0.15s ease",
    "&:hover": {
      boxShadow: theme.shadows[6],
      transform: "translateY(-2px)",
    },
  },
  cardIcon: {
    fontSize: 48,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
}));

export default function BoomReportPage() {
  const classes = useCardStyles();
  const [activePanel, setActivePanel] = useState(null);

  return (
    <AdminContainer variant="list">
      <Box display="flex" alignItems="center" mb={2}>
        {activePanel && (
          <IconButton
            className={classes.backButton}
            onClick={() => setActivePanel(null)}
            size="small"
          >
            <BackIcon />
          </IconButton>
        )}
        <Typography variant="h5">
          {activePanel === "billing"
            ? "Billing Monitoring"
            : activePanel === "enrollment"
              ? "Enrollment Status Monitoring"
              : "Boom Report"}
        </Typography>
      </Box>

      {!activePanel && (
        <Box className={classes.cardGrid}>
          <Paper className={classes.card} onClick={() => setActivePanel("billing")}>
            <BillingIcon className={classes.cardIcon} />
            <Typography variant="h6">Billing Monitoring</Typography>
            <Typography variant="body2" color="textSecondary" align="center">
              Monthly charges, forecasts, and partner breakdowns
            </Typography>
          </Paper>
          <Paper className={classes.card} onClick={() => setActivePanel("enrollment")}>
            <StatsIcon className={classes.cardIcon} />
            <Typography variant="h6">Status Permutation Monitoring</Typography>
            <Typography variant="body2" color="textSecondary" align="center">
              Enrollment case partner status combinations and anomalies
            </Typography>
          </Paper>
        </Box>
      )}

      {activePanel === "billing" && <BillingPanel />}
      {activePanel === "enrollment" && <EnrollmentStatsPanel />}
    </AdminContainer>
  );
}
